import {PORTRAITS} from '../pages/choose-my-portrait';
import {COVERS} from '../pages/choose-my-cover';
import {IMAGES} from '../pages/choose-my-image';

interface ModImageProp {
  imageSrc: string;
  id: number;
}

interface ModSettingsProp {
  type: string;
  slug: string;
  label: string;
  cta: string;
  images: null | ModImageProp[];
}

export const modSettings: ModSettingsProp[] = [
  {
    type: 'sign-stamp',
    slug: 'add-your-signature',
    label: 'Update my signature',
    cta: 'Add my signature',
    images: null,
  },
  {
    type: 'flip-coin',
    slug: 'flip-the-coin',
    label: 'Flip the Coin',
    cta: 'Choose how to display your coin',
    images: [
      {
        imageSrc: '/assets/front-coin.png',
        id: 0,
      },
      {
        imageSrc: '/assets/back-coin.png',
        id: 1,
      },
    ],
  },
  {
    type: 'select-portrait',
    slug: 'choose-my-portrait',
    label: 'Choose your Portrait',
    cta: 'Personalise my portrait',
    images: PORTRAITS as ModImageProp[],
  },
  {
    type: 'select-image',
    slug: 'choose-my-image',
    label: 'Choose your Image',
    cta: 'Personalise my artwork',
    images: IMAGES as ModImageProp[],
  },
  {
    type: 'select-cover',
    slug: 'choose-my-cover',
    label: 'Choose your Page',
    cta: 'Choose my page',
    images: COVERS,
  },
];

export const getModSettingsByType = (type: string): ModSettingsProp => {
  return modSettings.find((mod) => {
    return mod.type === type;
  }) as ModSettingsProp;
};
